// src/components/Header.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import { HashLink } from 'react-router-hash-link';
import logo from "../assets/images/ilt_logo.png";

const HEADER_OFFSET = 100; // height of your sticky header in px

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

useEffect(() => {
  if (location.hash) {
    const id = location.hash.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 100; // height of your sticky header in px
      const top = element.offsetTop - headerHeight; // subtract header height

      // Temporarily disable smooth scroll
      const html = document.documentElement;
      const originalScrollBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';

      // Jump to position with offset
      window.scrollTo({
        top,
        left: 0,
      });

      html.style.scrollBehavior = originalScrollBehavior;
    }
  }
}, [location]);


  return (
      <header className="header">
       
         <HashLink
    to="/#home"
    scroll={(el) => {
      if (!el) return;

      // Calculate where to scroll instantly (account for header height)
      const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;

      // Temporarily disable smooth scroll
      const html = document.documentElement;
      const previous = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';

      // Jump instantly
      window.scrollTo({ top: y, left: 0 });

      // Restore original scroll behavior
      setTimeout(() => {
        html.style.scrollBehavior = previous;
      }, 0);
    }}
  >
    <div className="logo">
      <img src={logo} alt="Logo" />
    </div>
  </HashLink>

        <nav className="nav">
          <a href="/#home">Home</a>

          <HashLink
            to="/#about"
            scroll={el => {
              if (!el) return;
              // compute absolute top of element
              const rect = el.getBoundingClientRect();
              const targetY = rect.top + window.pageYOffset - HEADER_OFFSET;
          
              // temporarily disable CSS smooth scroll on <html>
              const html = document.documentElement;
              const prevScrollBehavior = html.style.scrollBehavior;
              html.style.scrollBehavior = 'auto';
          
              // jump instantly
              window.scrollTo(0, Math.max(0, targetY));
          
              // restore previous behavior (do it async to avoid race with browser)
              // setTimeout 0 ensures browser processed the jump
              setTimeout(() => {
                html.style.scrollBehavior = prevScrollBehavior;
              }, 0);
            }}
          >
            About
          </HashLink>

          <a href="/projects">Projects</a>
         <a href="/services">Services</a>

<HashLink
            to="/#contact"
            scroll={el => {
              if (!el) return;
              // compute absolute top of element
              const rect = el.getBoundingClientRect();
              const targetY = rect.top + window.pageYOffset - HEADER_OFFSET;
          
              // temporarily disable CSS smooth scroll on <html>
              const html = document.documentElement;
              const prevScrollBehavior = html.style.scrollBehavior;
              html.style.scrollBehavior = 'auto';
          
              // jump instantly
              window.scrollTo(0, Math.max(0, targetY));
          
              // restore previous behavior (do it async to avoid race with browser)
              // setTimeout 0 ensures browser processed the jump
              setTimeout(() => {
                html.style.scrollBehavior = prevScrollBehavior;
              }, 0);
            }}
          >
            Contact
          </HashLink>
        </nav>
      </header>
  );
};

export default Header;
